import React, { useRef, useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Message } from "../../../types/chatTypes";
import { MessageBubble } from './MessageBubble';
import { ThinkingBubble } from './ThinkingBubble';
import { useChat } from '../../../contexts/ChatContext';

interface ChatMessagesListProps {
    messages: Message[];
    isThinking: boolean;
}

export const ChatMessagesList: React.FC<ChatMessagesListProps> = ({ messages, isThinking }) => {
    const messagesEndRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, isThinking]);

    return (
        <Box sx={{
            flexGrow: 1,
            minHeight: 0,
            width: '100%',
            boxSizing: 'border-box',
            overflowY: 'auto',
            overflowX: 'hidden',
            p: 2,
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Stack spacing={2} sx={{ width: '100%', minWidth: 0 }} data-tour={"ai_ask_message_list"}>
                {messages.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
                        No messages yet. Start the conversation!
                    </Typography>
                ) : (
                    messages.map((msg, indx) => <MessageBubble key={msg.id} message={msg} lastMessages={indx >= messages.length - 2} />)
                )}
                {isThinking && <ThinkingBubble />}

                <div ref={messagesEndRef} />
            </Stack>
        </Box>
    );
};